import { Controller } from "stimulus"
import Inputmask from "inputmask"

const DEFAULT_MASK = "(999) 999-9999"

export default class extends Controller {
  connect() {
    Inputmask(this.mask).mask(this.element)
  }

  disconnect() {
    if (this.element.inputmask) {
      this.element.inputmask.remove()
    }
  }

  get mask() {
    return this.data.get("mask") || DEFAULT_MASK
  }
}
